<template>
  <div>
    <hr>
    <p><strong>{{ $t('register.hintText') }}</strong></p>
    <ul>
      <li>{{ $t('register.hint1') }}</li>
      <li>{{ $t('register.hint2') }}</li>
      <li>{{ $t('register.hint3') }}</li>
    </ul>
  </div>    
</template>

<script>
export default {
    name: 'EmailHints',
    data: ()=>({
        
    })
}
</script>

<style lnag="scss">
 ul {
     font-size:13px;
 }
</style>
